import React from "react";
import { nearbyCollectorsLabel } from "../nearbyCollectors";

/**
 * NearbyCollectorsStatus — one calm pill under the top row.
 *
 * It renders a count and nothing else, and only when that count is true: the
 * caller gates it through `shouldShowNearbyPill`, which now also takes the
 * discovery status so a failed or throttled load can never print a number.
 *
 * The radar pulse this pill used to carry is gone. A count that idles forever
 * implies the map is still working; it isn't, it already finished.
 */
const NearbyCollectorsStatus = ({ count, top, transition }) => (
  <div
    data-testid="nearby-collectors-pill"
    aria-live="polite"
    style={{
      position: "absolute",
      top,
      transition,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 9,
      display: "flex",
      alignItems: "center",
      gap: 7,
      padding: "7px 14px",
      borderRadius: 999,
      background: "rgba(255,255,255,0.96)",
      border: "1px solid rgba(15,23,42,0.08)",
      boxShadow: "0 4px 14px rgba(15,23,42,0.12)",
      pointerEvents: "none",
    }}
  >
    <span
      aria-hidden="true"
      style={{ width: 6, height: 6, borderRadius: "50%", background: "#16a34a" }}
    />
    <span
      style={{
        fontSize: 12.5,
        fontWeight: 700,
        letterSpacing: "-0.01em",
        whiteSpace: "nowrap",
        color: "#0f172a",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {nearbyCollectorsLabel(count)}
    </span>
  </div>
);

export default NearbyCollectorsStatus;
